export enum AlertBoxType {
    info,
    warning,
    error,
    success
}